export default __webpack_public_path__ + "ocr/worker.min-f01085aa57f7f590498ade1034a9c7d5.js";